// extracted by mini-css-extract-plugin
export default {"modalFooterButtons":"OrderStatusEditionModal_modalFooterButtons__I4jOQ"};